<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconNotAuthenticated_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.25 12.542q1.584 2.18 4.017 2.791 2.432-.612 4.016-2.79 1.584-2.18 1.584-4.84v-4.27l-5.6-2.1-5.6 2.1v4.27q0 2.66 1.584 4.84M8 11.333A.667.667 0 0 0 8 10h-.007a.667.667 0 0 0 0 1.333zM7.333 8a.667.667 0 0 0 1.334 0V5.333a.667.667 0 0 0-1.334 0z"
        clip-rule="evenodd"
    />
</svg>
